module.exports = __webpack_public_path__ + "img/suleimanova_500.bd7dcaea.jpg";